import React, {Component} from 'react';
import PercentChart from './PercentChart';

export default class ROA extends Component {
  render() {
    return <PercentChart up title='ROA' upDownPercent='15.80%' percent='1.90%' />;
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/PercentChart/ROA.js